// extracted by mini-css-extract-plugin
export default {"root":"styles_root__30Jfb","imageContainer":"styles_imageContainer__0NhU5"};